// extracted by mini-css-extract-plugin
export default {"container":"Au-z","ratingLayout":"Bu-z","ratingLabel":"Cu-z","nonInteractiveRatingLabel":"Du-z"};